'use client';

import { AnchoredRegion, anchoredRegionTag } from '@ni/nimble-components/dist/esm/anchored-region';
import { wrap } from '../utilities/react-wrapper';

export { anchoredRegionTag };
export { type AnchoredRegion };
export const NimbleAnchoredRegion = wrap(AnchoredRegion);
